import { useQuery } from 'react-query';
import { queryPendingEntity } from './usePendingEntity.query';
import { UsePendingEntityOptions } from './usePendingEntity.types';
import { Entity } from '../../../types/models/entity/entity.types';

export const PENDING_ENTITY_QUERY_KEY = 'PENDING_ENTITY';

export const usePendingEntity = (options?: UsePendingEntityOptions) => {
  return useQuery<Entity, Error>(PENDING_ENTITY_QUERY_KEY, () => queryPendingEntity(), {
    ...options,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
